import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import type { BreadcrumbItem } from '@shared/components/navigation/types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const OrderPreparationBreadcrumb = () => {
  const { t } = useTranslation('orderpreparationModule');

  const breadcrumbs = useMemo<BreadcrumbItem[]>(() => {
    const title = t('breadcrumb.order_preparation', 'Preparación de pedidos');
    return [
      {
        label: title,
        title: title,
      },
    ];
  }, [t]);

  usePageNavigation({ breadcrumbs });

  return null;
};
